/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    GET_SEARCH_RECAREA,
    GET_SEARCH_RECAREA_NAME,
    GET_SEARCH_RECAREA_NAME_ERROR,
    GET_SEARCH_RECAREA_ERROR,
} from '../constants';

const INITIALSTATE = {
    results: {
        isLoading: true,
    },
};

export default function recarea(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case GET_SEARCH_RECAREA_NAME:
            st.results = { ...action.payload, ...{ isLoading: false } };
            delete st.err;
            return st;

        case GET_SEARCH_RECAREA:
            st.results = action.payload;
            delete st.err;
            return st;

        case GET_SEARCH_RECAREA_NAME_ERROR:
            st.err = action.err;
            st.results = { isLoading: false };
            return st;

        case GET_SEARCH_RECAREA_ERROR:
            st.err = action.err;
            return st;

        default:
            return st;
    }
}
